import { Component, inject } from '@angular/core';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-abschrift-editor',
	templateUrl: './aufgabe-abschrift-editor.component.html',
	styleUrls: ['./aufgabe-abschrift-editor.component.scss'],
	standalone: false,
})
export class AufgabeAbschriftEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	get formGroup() {
		return this.formService.form.controls.REGISTERABSCHRIFT;
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}

	protected readonly AufgabenTyp = AufgabenTyp;
}
